<template>
  <g>
    <text
      v-for="l in lines"
      fill="white"
      :key="l.text"
      :x="l.x"
      :y="l.y"
      :class="cssClass"
      text-anchor="middle"
      >{{ l.text }}</text
    >
  </g>
</template>
<script>
import {
  filterIllegalCharacters,
  filterTooLongLines,
  filterTooManyLines,
} from '../../util/filterInput.js'

export default {
  name: 'PosterText',
  props: {
    text: {
      type: String,
      required: true,
    },
    xCenter: {
      type: Number,
      required: true,
    },
    yCenter: {
      type: Number,
      required: true,
    },
    cssClass: {
      type: String,
      required: true,
    },
  },
  computed: {
    lines: function() {
      const lines = filterIllegalCharacters(
        filterTooLongLines(filterTooManyLines(this.text))
      ).split('\n')
      const firstLineStart = this.yCenter - 10 * (lines.length - 1)
      return lines.map((line, index) => {
        return {
          text: line,
          x: this.xCenter,
          y: firstLineStart + 20 * index,
        }
      })
    },
  },
}
</script>
